{
  "CONTENT_TEMPLATES": {
    "MODAL": {
      "TITLE": "Twilio Templates",
      "SUBTITLE": "Select the Twilio template you want to send",
      "TEMPLATE_SELECTED_SUBTITLE": "Configure template: {templateName}"
    },
    "PICKER": {
      "SEARCH_PLACEHOLDER": "Search Templates",
      "NO_TEMPLATES_FOUND": "No templates found for",
      "NO_CONTENT": "No content",
      "HEADER": "Header",
      "BODY": "Body",
      "FOOTER": "Footer",
      "BUTTONS": "Buttons",
      "CATEGORY": "Category",
      "MEDIA_CONTENT": "Media Content",
      "MEDIA_CONTENT_FALLBACK": "media content",
      "NO_TEMPLATES_AVAILABLE": "No Twilio templates available. Click refresh to sync templates from Twilio.",
      "REFRESH_BUTTON": "Refresh templates",
      "REFRESH_SUCCESS": "Templates refresh initiated. It may take a couple of minutes to update.",
      "REFRESH_ERROR": "Failed to refresh templates. Please try again.",
      "LABELS": {
        "LANGUAGE": "Language",
        "TEMPLATE_BODY": "Template Body",
        "CATEGORY": "Category"
      },
      "TYPES": {
        "MEDIA": "Media",
        "QUICK_REPLY": "Quick Reply",
        "CALL_TO_ACTION": "Call to Action",
        "TEXT": "Text"
      }
    },
    "PARSER": {
      "VARIABLES_LABEL": "Variables",
      "LANGUAGE": "Language",
      "CATEGORY": "Category",
      "VARIABLE_PLACEHOLDER": "Enter {variable} value",
      "GO_BACK_LABEL": "Go Back",
      "SEND_MESSAGE_LABEL": "Send Message",
      "FORM_ERROR_MESSAGE": "Please fill all variables before sending",
      "MEDIA_HEADER_LABEL": "{type} Header",
      "MEDIA_URL_LABEL": "Enter full media URL",
      "MEDIA_URL_PLACEHOLDER": "https://example.com/image.jpg"
    },
    "FORM": {
      "BACK_BUTTON": "Back",
      "SEND_MESSAGE_BUTTON": "Send Message"
    }
  }
}
